var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4173 6.34111L7.28155 11.6509H5.90779L7.04365 6.34111H8.4173ZM14.1966 9.76973L14.9196 7.77579L15.3357 9.76973H14.1966ZM15.7298 11.6509H17L15.8903 6.34111H14.7186C14.4545 6.34111 14.2319 6.49422 14.1334 6.73033L12.0722 11.6509H13.5149L13.8013 10.8579H15.5634L15.7298 11.6509ZM12.1438 9.91746C12.1497 8.51611 10.2065 8.43848 10.2196 7.81233C10.2237 7.62208 10.4053 7.41942 10.802 7.36759C10.9987 7.34227 11.5415 7.32173 12.1568 7.60524L12.3974 6.47881C12.067 6.35927 11.6417 6.24414 11.1125 6.24414C9.75452 6.24414 8.79922 6.96548 8.79158 7.99923C8.78286 8.76368 9.47398 9.18991 9.99361 9.44453C10.5294 9.70476 10.7089 9.8716 10.7062 10.1041C10.7025 10.4604 10.279 10.6181 9.88469 10.6241C9.19369 10.6349 8.79313 10.4373 8.47391 10.2885L8.22454 11.4526C8.54604 11.5997 9.13839 11.7277 9.75177 11.7343C11.1955 11.7343 12.1395 11.0214 12.1438 9.91746ZM6.4544 6.34111L4.22865 11.6509H2.77679L1.68141 7.41333C1.615 7.15274 1.55708 7.05696 1.35513 6.94685C1.0248 6.76747 0.479497 6.59967 0 6.49529L0.0324844 6.34111H2.3699C2.66763 6.34111 2.9355 6.53924 3.0037 6.88224L3.58232 9.95508L5.01125 6.34111H6.4544Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9676a5f165a6a4885feccba2430d8191.svg";
export { ForwardRef as ReactComponent };